import * as Sentry from '@sentry/react';

/**
 * Sends user feedback via Sentry
 * @param {Object} feedbackData - Feedback data
 * @param {string} feedbackData.name - User name
 * @param {string} feedbackData.email - User email
 * @param {string} feedbackData.message - Feedback message
 * @param {string} feedbackData.level - Feedback criticity level
 * @param {string} feedbackType - Type of feedback (suggestion, problem, critical)
 * @returns {Promise<void>}
 */
export async function sendFeedback({ name, email, message, level }, feedbackType) {
  try {
    Sentry.setUser({
      email: email?.trim(),
      username: name
    });

    const captureFeedback = {
      name,
      email: email?.trim(),
      message
    };

    // Include replay to provide additional context for debugging
    const options = {
      captureContext: {
        tags: { key: feedbackType },
        level: level || 'info'
      },
      includeReplay: true
    };

    Sentry.captureFeedback(captureFeedback, options);

  } catch (error) {
    console.error('Erreur lors de l\'envoi du feedback:', error);
    throw error;
  }
}

/**
 * Prepares username with fallback strategy
 * @param {Object} user - User object
 * @param {string} email - Fallback email
 * @returns {string} Username or email as fallback
 */
export function prepareUserName(user, email) {
  return user?.name || user?.firstName || email?.trim();
}